var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 9.66994C17.3123 9.48369 17.0589 9.37915 16.7947 9.37915C16.5305 9.37915 16.2771 9.48369 16.0897 9.66994L12.4997 13.2099L8.9597 9.66994C8.77234 9.48369 8.51889 9.37915 8.2547 9.37915C7.99052 9.37915 7.73707 9.48369 7.5497 9.66994C7.45598 9.76291 7.38158 9.87351 7.33081 9.99537C7.28004 10.1172 7.25391 10.2479 7.25391 10.3799C7.25391 10.512 7.28004 10.6427 7.33081 10.7645C7.38158 10.8864 7.45598 10.997 7.5497 11.0899L11.7897 15.3299C11.8827 15.4237 11.9933 15.4981 12.1151 15.5488C12.237 15.5996 12.3677 15.6257 12.4997 15.6257C12.6317 15.6257 12.7624 15.5996 12.8843 15.5488C13.0061 15.4981 13.1167 15.4237 13.2097 15.3299L17.4997 11.0899C17.5934 10.997 17.6678 10.8864 17.7186 10.7645C17.7694 10.6427 17.7955 10.512 17.7955 10.3799C17.7955 10.2479 17.7694 10.1172 17.7186 9.99537C17.6678 9.87351 17.5934 9.76291 17.4997 9.66994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUAngleDown);
export default __webpack_public_path__ + "static/media/u_angle-down.c4d446863b6c8219c72e2149828173ce.svg";
export { ForwardRef as ReactComponent };